export default {
  common: {
    account: 'アカウント',
    signOut: 'サインアウト',
    search: '検索',
    clear: 'クリア',
    tilde: '~',
    edit: '編集',
    detail: '詳細',
    operation: '操作',
    confirm: '確認',
    back: '戻る',
    cancel: 'キャンセル',
    yen: '円',
    note: 'メモ',
    invalidTimeRange: '開始時間と終了時間を正しく設定してください。',
    csvExport: 'CSV出力'
  },
  paymentStatus: {
    CREATED: '作成済み',
    AUTHORIZED: '認証済み',
    CAPTURED: '取引成功',
    REFUNDED: '払戻済',
    CANCELED: 'キャンセル済み',
    FAILED: '失敗',
    INTERNAL_ERROR: '取引エラー'
  },
  payMethod: {
    PAYPAY: 'PayPay',
    CARD: 'クレジットカード',
    WECHATPAY: 'WechatPay',
    ALIPAY: 'Alipay',
    PAY_METHOD_UNSPECIFIED: 'その他'
  },
  paymentFiltersType: {
    LIST: 'リスト',
    SEARCH: '検索'
  },
  views: {
    dashboard: {
      title: 'ダッシュボード'
    },
    login: {
      title: 'Welcome to Linktivity Payment Admin',
      googleLogin: 'Googleでログイン'
    },
    payment: {
      title: '支払管理',
      createdAt: '支払日時',
      merchantTransactionId: 'Booking ID',
      id: '取引ID',
      email: 'メールアドレス',
      merchantId: '加盟店ID',
      supplierManageId: '加盟店管理ID',
      status: '支払状態',
      payMethod: '支払方法',
      amount: '金額',
      refundAmount: '払戻金額',
      refund: '払戻する',
      refundProcess: '払戻処理',
      refundedAt: '払い戻し日時',
      metadata: 'メタデータ',
      products: '商品',
      operationInfo: '操作情報',
      refundNote: `下記の支払いの払い戻し処理を行いますか？
必ずキャンセル内容を確認してください。`,
      refundAdjustment: '差額調整の場合',
      refundSuccess: '払い戻し処理が完了しました',
      selectField: '検索する項目を選択してください',
      capture: 'キャプチャー',
      captureNote: `この支払いのキャプチャー処理を行いますか？`,
      captureSuccess: 'キャプチャー処理が完了しました',
      downloadSuccess: 'CSVファイルをダウンロードしました'
    },
    paymentDetailProduct: {
      productId: '商品ID',
      productTitle: '商品名',
      productThumbnailUrl: '商品画像',
      productItems: '商品アイテム'
    },
    paymentDetailOperation: {
      captureOperator: 'キャプチャー担当者',
      captureComment: 'キャプチャーコメント',
      refundOperator: '払い戻し担当者',
      refundComment: '払い戻しコメント'
    }
  }
};
